/* unplugin-vue-components disabled */import { render } from "./E808EPlusRender.vue?vue&type=template&id=36a0771c&scoped=true"
import script from "./E808EPlusRender.vue?vue&type=script&lang=js"
export * from "./E808EPlusRender.vue?vue&type=script&lang=js"

import "./E808EPlusRender.vue?vue&type=style&index=0&id=36a0771c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a0771c"]])

export default __exports__